export default __webpack_public_path__ + "static/media/NewYork.242952a7.jpeg";